import React, { Component } from 'react';
import PropTypes from 'prop-types';

let HeadroomJS;

/* eslint-disable */
try {
  HeadroomJS = require('headroom.js');
} catch (e) {}
/* eslint-enable */

class Headroom extends Component {
  static propTypes = {
    options: PropTypes.shape(),
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    options: {
      tolerance: {
        up: 5,
        down: 5,
      },
      offset: 0,
      classes: {
        pinned: 'headroom--pinned',
        unpinned: 'headroom--unpinned',
        top: 'headroom--top',
        notTop: 'headroom--not-top',
        bottom: 'headroom--bottom',
        notBottom: 'headroom--not-bottom',
        initial: 'headroom',
      },
    },
  };

  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  }

  componentDidMount() {
    this.headroom = new HeadroomJS(this.myRef.current, this.props.options);
    this.headroom.init();
  }

  componentWillUnmount() {
    if (!this.headroom.scrollTracker) {
      this.headroom.scrollTracker = {
        destroy: () => {},
      };
    }
    this.headroom.destroy();
  }

  render() {
    return React.cloneElement(this.props.children, { ref: this.myRef });
  }
}

export default Headroom;
